module.exports = __webpack_public_path__ + "img/advise.aa328dc6.png";